import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<SessionPublicationcheck @session={{@model}} />\n", {
  moduleName: "ilios-common/templates/session/publication-check.hbs"
});